module.exports = " <div id=container _v-7e97f54c=\"\"> <i id=selectfiles class=\"icon uploader-icon\" _v-7e97f54c=\"\"> </i> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-7e97f54c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploaderPlugin.vue
// module id = 66
// module chunks = 1